import * as React from 'react';
import { flow, each, get } from 'lodash';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { actions as quoteActions } from '../../../../../../services/quote/reducer';
import {IDriver, IVehicle} from '../../../../../../data/api/models';
import Vehicle from '../Vehicle';
import * as uuid from 'uuid/v4';
import * as moment from 'moment';

interface IVehiclesProps {
  count: number;
  vehicles: IVehicle[];
  drivers: IDriver[];
  excessOverrides: any;
  fields: any;
  weightOptions: any;
  coverOptions: any;
  drivingRestrictionOptions: any;
  drivingRestrictionRules: any;
  extendedUseTypes: any;
  mileageOptions: any;
  ownershipOptions: any;
  trackerOptions: any;
  dispatch: any;
  change: any;
  renderDefinition: any;
  proposerName: string;
  proposerPostcode: string;
  schemeId: string;
  duplicateRegistration: number;
}

const defaults = {
  bodyType: 'Horsebox',
  roadRegistered: 'true',
  registrationNumber: '',
  registrationNumberSearched: false,
  make: '',
  model: '',
  year: '',
  weight: '',
  value: null,
  coverType: '',
  drivingRestriction: '',
  drivingRestrictionCalculated: '',
  showExtendedUse: false,
  extendedUses: [false, false, false, false, false],
  greenCard: '',
  mileage: '',
  proposerOwner: '',
  owner: '',
  ownerName: '',
  proposerOvernight: '',
  postcode: '',
  tracker: '',
  breakdownCover: '',
  use: 'Social, Domestic, Pleasure And Commuting',
  ncd: '9+',
  // age: '',
  // excessTheftLockedBuilding: 0,
  // excessTheftOther: 0,
  // excessAdft: 0,
};

class Vehicles extends React.Component<IVehiclesProps> {
  public componentDidMount() {
    const { fields, count } = this.props;
    let i;
    for (i = 0; i < count; i++) {
      if (i >= fields.length) {
        const newVehicleId = uuid();
        const defaultVehicle = {
          id: newVehicleId,
          ...defaults,
        };

        fields.push(defaultVehicle);
      }
    }
    for (i = fields.length - 1; i >= 0; i--) {
      if (i >= count) {
        fields.remove(i);
      }
    }
  }

  public componentWillReceiveProps(nextProps) {
    const { vehicles } = this.props;

    // check for referrals or declines
    if (vehicles !== nextProps.vehicles) {
      this.checkVehicles(nextProps.vehicles);
    }
  }

  public deleteVehicle = (index) => {
    const { fields, count, dispatch, change } = this.props;
    fields.remove(index);
    dispatch(change('vehicleCount', count - 1));
  }

  private checkVehicles(vehicles: IVehicle[]) {
    const { dispatch, change } = this.props;

    // vehicle year
    let age = false;

    each(vehicles, (vehicle) => {
      if (vehicle.year && (parseInt(vehicle.year, 10) < 1900 || parseInt(vehicle.year, 10) >
        parseInt(moment().format('YYYY'), 10))) {
        age = true;
      }
    });

    if (age) {
      dispatch(change('vehicleReferrals.vehicleAge', true));
    } else {
      dispatch(change('vehicleReferrals.vehicleAge', false));
    }

    // value
    let value = false;

    each(vehicles, (vehicle) => {
      if ((vehicle.value > 80000 && vehicles.length < 4) || (vehicle.value > 120000 && vehicles.length < 6)) {
        value = true;
      }
    });

    if (value) {
      dispatch(change('vehicleReferrals.vehicleValue', true));
    } else {
      dispatch(change('vehicleReferrals.vehicleValue', false));
    }
  }

  public render() {
    const {
      fields,
      weightOptions,
      coverOptions,
      drivingRestrictionOptions,
      drivingRestrictionRules,
      extendedUseTypes,
      mileageOptions,
      ownershipOptions,
      trackerOptions,
      proposerName,
      proposerPostcode,
      vehicles,
      dispatch,
      change,
      renderDefinition,
      drivers,
      excessOverrides,
      schemeId,
      duplicateRegistration,
    } = this.props;

    return (
      <div>
        {fields.map((vehicle, index) => {
          return (
            <div key={index}>
              <Vehicle
                name={vehicle}
                vehicle={vehicles[index]}
                index={index}
                removable={fields.length > 1}
                excessOverrides={excessOverrides}
                deleteVehicle={this.deleteVehicle}
                weightOptions={weightOptions}
                coverOptions={coverOptions}
                drivingRestrictionOptions={drivingRestrictionOptions}
                drivingRestrictionRules={drivingRestrictionRules}
                extendedUseTypes={extendedUseTypes}
                mileageOptions={mileageOptions}
                ownershipOptions={ownershipOptions}
                trackerOptions={trackerOptions}
                dispatch={dispatch}
                change={change}
                renderDefinition={renderDefinition}
                drivers={drivers}
                proposerName={proposerName}
                proposerPostcode={proposerPostcode}
                schemeId={schemeId}
                duplicateRegistration={duplicateRegistration === index}
              />
              {index + 1 !== fields.length && (
                <hr />
              )}
            </div>
          );
        })}
      </div>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore) => {
      const vehicles = selector(state, 'vehicles');
      const drivers = selector(state, 'drivers');
      const proposerName = selector(state, 'insured.companyName') ? selector(state, 'insured.companyName') :
        (selector(state, 'insured.firstName') + ' ' + selector(state, 'insured.lastName'));
      const proposerPostcode = selector(state, 'insured.address.postcode');
      const excessOverrides = selector(state, 'excessOverrides');

      return {
        quote: state.quote,
        vehicles,
        drivers,
        proposerName,
        proposerPostcode,
        excessOverrides,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({...quoteActions}, dispatch),
      },
    }),
  ),
])(Vehicles);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Vehicles/components/Vehicles/index.tsx